import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73099b55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contactWrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { style: {"padding":"0 16px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_CellGroup = _resolveComponent("CellGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar, { title: "User" }),
    _hoisted_2,
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "avatar",
          src: _ctx.user.info.avatarurl
        }, null, 8, _hoisted_3),
        _createElementVNode("p", null, "id: " + _toDisplayString(_ctx.user.userId), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.user.info.nickname,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.info.nickname) = $event)),
          rows: "1",
          autosize: "",
          label: "用户昵称",
          type: "input",
          center: "",
          placeholder: "用户昵称"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "primary",
              size: "small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.user.updateUserInfo('nickname', _ctx.user.info.nickname)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("更新")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.user.info.avatarurl,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.info.avatarurl) = $event)),
          rows: "1",
          autosize: "",
          label: "用户头像",
          type: "input",
          center: "",
          placeholder: "请输入头像的url地址"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "primary",
              size: "small",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.updateUserInfo('avatarurl', _ctx.user.info.avatarurl)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("更新")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.user.info.mail,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.info.mail) = $event)),
          rows: "1",
          autosize: "",
          label: "邮箱",
          type: "input",
          center: "",
          placeholder: "邮箱"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "primary",
              size: "small",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.user.updateUserInfo('mail', _ctx.user.info.mail)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("更新")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.user.info.phone,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.info.phone) = $event)),
          rows: "1",
          autosize: "",
          label: "手机号",
          type: "input",
          center: "",
          placeholder: "手机号"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "primary",
              size: "small",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.user.updateUserInfo('phone', _ctx.user.info.phone)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("更新")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.user.info.gender,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.info.gender) = $event)),
          rows: "1",
          autosize: "",
          label: "性别",
          type: "input",
          center: "",
          placeholder: "性别"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "primary",
              size: "small",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.user.updateUserInfo('gender', _ctx.user.info.gender)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("更新")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.user.info.birth,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.info.birth) = $event)),
          rows: "1",
          autosize: "",
          label: "生日",
          type: "input",
          center: "",
          placeholder: "生日"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "primary",
              size: "small",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.user.updateUserInfo('birth', _ctx.user.info.birth)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("更新")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Button, {
        size: "small",
        type: "primary",
        onClick: _ctx.user.setting,
        block: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("设置")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_7,
      _createVNode(_component_Button, {
        size: "small",
        type: "danger",
        onClick: _ctx.user.deleteAllMessages,
        block: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("清除聊天记录")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_8,
      _createVNode(_component_Button, {
        size: "small",
        onClick: _ctx.user.logout,
        block: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("退出登录")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}